import MailsPage from './MailsPage';

export default MailsPage;